import {refundSvg as Icon__small__refundSvg} from '../Icon__small/Icon__small--refund.js';
import {refundSvg as Icon__xsmall__refundSvg} from '../Icon__xsmall/Icon__xsmall--refund.js';

export var refund = {
  name: 'refund',
  category: 'icon',
  colorable: true,
  svg: Icon__small__refundSvg,
  alt: {
    Icon__small: Icon__small__refundSvg,
    Icon__xsmall: Icon__xsmall__refundSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
